const Config = {
  baseUrl: "https://api.bmwriters.com",
};

export const secretKey="abcd12341234323avsbdfdddd"

export default Config;
